import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Shared page header used across monetization / settings / safety / etc.
 */
export const PageHeader = ({ title, subtitle, right, onBack, testId = "page-header" }) => {
    const navigate = useNavigate();
    return (
        <header
            className="px-4 pt-[max(14px,env(safe-area-inset-top))] pb-3 border-b border-border/60"
            data-testid={testId}
        >
            <div className="flex items-center justify-between gap-2">
                <button
                    onClick={onBack || (() => navigate(-1))}
                    data-testid={`${testId}-back`}
                    className="h-10 w-10 flex items-center justify-center rounded-xl hover:bg-muted active:scale-95"
                    aria-label="Back"
                >
                    <ArrowLeft size={20} />
                </button>
                <div className="flex-1 min-w-0 text-center">
                    <h1 className="font-display text-[16px] font-semibold truncate">{title}</h1>
                    {subtitle && (
                        <p className="text-[11.5px] text-muted-foreground truncate">{subtitle}</p>
                    )}
                </div>
                <div className="h-10 w-10 flex items-center justify-center">{right}</div>
            </div>
        </header>
    );
};

export const GradientButton = ({ children, onClick, disabled, testId, tall = true }) => (
    <button
        onClick={onClick}
        disabled={disabled}
        data-testid={testId}
        className={[
            "w-full rounded-2xl font-medium text-[15px] text-primary-foreground",
            "transition-[transform,opacity] duration-200 active:scale-[0.98]",
            "disabled:cursor-not-allowed disabled:opacity-60",
            tall ? "h-14" : "h-12",
        ].join(" ")}
        style={{
            background:
                "linear-gradient(135deg, hsl(var(--primary)), hsl(var(--primary) / 0.78))",
            boxShadow: "0 10px 28px -10px hsl(var(--primary) / 0.55)",
        }}
    >
        {children}
    </button>
);

export const Row = ({ icon: Icon, label, right, onClick, testId, danger }) => (
    <button
        onClick={onClick}
        data-testid={testId}
        className="w-full flex items-center gap-3 p-3.5 rounded-2xl hover:bg-accent/40 active:scale-[0.99] transition-[transform,background-color] duration-150 text-left"
    >
        {Icon && (
            <span
                className={[
                    "h-10 w-10 rounded-xl flex items-center justify-center shrink-0",
                    danger ? "bg-destructive/10 text-destructive" : "bg-primary/10 text-primary",
                ].join(" ")}
            >
                <Icon size={18} strokeWidth={2.2} />
            </span>
        )}
        <span className={["flex-1 text-[14px] font-medium", danger ? "text-destructive" : ""].join(" ")}>
            {label}
        </span>
        {right}
    </button>
);

export const SectionTitle = ({ children }) => (
    <h3 className="px-5 mt-5 mb-1.5 text-[11px] uppercase tracking-[0.14em] font-semibold text-muted-foreground">
        {children}
    </h3>
);
